// extracted by mini-css-extract-plugin
export default {"root":"iLFGV","text":"prdgV","icon":"pQFUc"};